module.exports = __webpack_public_path__ + "static/media/PR.fcec6063.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PR.svg
// module id = 2242
// module chunks = 7